export const isDevelopmentEnvironment = (): boolean => {
	return process.env.RUN_ENV === 'development';
};
